import React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import UnstyledButton from 'components/button/unstyled-button'
import { FiPlus } from '@react-icons/all-files/fi/FiPlus'
import { FiMinus } from '@react-icons/all-files/fi/FiMinus'

const CollapseHeader = ({ children, isOpened, ...props }) => {
  return (
    <CollapseHeaderContainer {...props}>
      <div>{children}</div>
      <div className='collapse-icon'>
        {isOpened ? (
          <FiMinus aria-hidden='true' focusable='false' role='presentation' />
        ) : (
          <FiPlus aria-hidden='true' focusable='false' role='presentation' />
        )}
      </div>
    </CollapseHeaderContainer>
  )
}

CollapseHeader.propTypes = {
  children: PropTypes.node.isRequired,
  isOpened: PropTypes.bool.isRequired,
}

const CollapseHeaderContainer = styled(UnstyledButton)`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  width: 100%;

  > div {
    :first-child {
      flex-grow: 2;
    }
  }

  svg {
    height: 1em;
    width: 1em;
  }
`

export default CollapseHeader
